// Efecto global (montado UNA vez en App): en cuanto hay sesión activa y existe una
// intención de checkout guardada (flujo B), lanza el checkout y
// redirige a Stripe. Cubre los tres caminos post-auth: login con contraseña, registro
// nuevo confirmado por email (vuelve por /auth/callback) y usuario ya logueado que
// llega a /login?plan=…&interval=… (LoginPage guarda la intención antes de redirigir).
import { useEffect } from 'react';
import { toast } from 'sonner';
import { supabase } from '@/integrations/supabase/client';
import { getPendingCheckout, launchCheckout } from '@/lib/pendingCheckout';

export function usePendingCheckout(): void {
  useEffect(() => {
    let cancelled = false;

    async function maybeLaunch(hasSession: boolean) {
      if (cancelled || !hasSession) return;
      const pending = getPendingCheckout();
      if (!pending) return;
      const ok = await launchCheckout(pending.plan, pending.interval);
      if (!ok && !cancelled) {
        toast.error('No se pudo iniciar el pago', {
          description: 'Vuelve a intentarlo desde tu plan.',
        });
      }
    }

    supabase.auth.getSession().then(({ data }) => maybeLaunch(!!data.session));
    const { data: sub } = supabase.auth.onAuthStateChange((_event, session) => {
      void maybeLaunch(!!session);
    });

    return () => {
      cancelled = true;
      sub.subscription.unsubscribe();
    };
  }, []);
}
